interface SectionHeadProps {
  eyebrow: string;
  title: string;
  desc?: string;
  accent?: boolean;
  light?: boolean;
  center?: boolean;
}

export default function SectionHead({
  eyebrow,
  title,
  desc,
  accent = false,
  light = false,
  center = false,
}: SectionHeadProps) {
  const base =
    light ? "text-background-50" : "text-foreground-950";
  const muted = light ? "text-background-300" : "text-foreground-600";
  return (
    <div className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <span
        className={
          accent
            ? "inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-accent-400"
            : "inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600"
        }
      >
        <i className="ri-flashlight-fill" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2
        className={`mt-3 font-serif text-3xl font-bold leading-tight md:text-4xl ${base}`}
      >
        {title}
      </h2>
      {desc ? (
        <p className={`mt-4 text-sm leading-7 md:text-[15px] ${muted}`}>{desc}</p>
      ) : null}
    </div>
  );
}